export default function RetiredScreen()
{
	return (
		<div className={'retired-landing-page-container'}>
			<p className={'retire-notice-text'}>
				Thank you for your interest. This standalone demo has been retired and its functionality 
				is now available directly within Firewriter on active quotes — giving you a more seamless 
				experience right where you work. To access these features, open an active quote in Firewriter. 
			</p>
			<p className={'retire-notice-text'}>
				For questions about availability or access, please reach out to your sales representative.
			</p>
			<a 
				href="https://firewriter.firedex.com"
				className={'submit-button'}
			>Visit Firewriter</a>
		</div>
	)
}
